import { Link, useNavigate } from "react-router-dom";
import { ShieldPlus, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const navCls =
  "px-2 sm:px-4 text-xs tracking-[0.1em] sm:tracking-[0.15em] uppercase font-bold hover:text-primary hover:bg-transparent";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-30 bg-[#0A0A0A] border-b border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-2">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2.5 shrink-0">
          <span className="w-8 h-8 grid place-items-center bg-primary">
            <ShieldPlus className="w-5 h-5 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-display font-black tracking-tighter text-lg uppercase">
            ECI-<span className="text-primary">Guard</span>
          </span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2 shrink-0">
          {user ? (
            <>
              <Button
                variant="ghost"
                data-testid="nav-dashboard-button"
                onClick={() => navigate("/dashboard")}
                className={navCls}
              >
                Dashboard
              </Button>
              {user.role === "admin" && (
                <Button
                  variant="ghost"
                  data-testid="nav-admin-button"
                  onClick={() => navigate("/admin")}
                  className={navCls}
                >
                  Factory
                </Button>
              )}
              <Button
                variant="outline"
                data-testid="nav-logout-button"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="rounded-none border-border px-2 sm:px-4 text-xs tracking-[0.1em] sm:tracking-[0.15em] uppercase font-bold gap-2"
              >
                <LogOut className="w-3.5 h-3.5" />
                <span className="hidden sm:inline">Exit</span>
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                data-testid="nav-login-button"
                onClick={() => navigate("/login")}
                className={navCls}
              >
                Sign in
              </Button>
              <Button
                data-testid="nav-register-button"
                onClick={() => navigate("/register")}
                className="rounded-none bg-primary hover:bg-[#FF5C53] px-3 sm:px-4 text-xs tracking-[0.1em] sm:tracking-[0.15em] uppercase font-bold"
              >
                Register
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
